import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, IconButton } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { applyIndexChanges, moveDocumentToIndex } from '../../actions/documentTools';
import { getDocumentsAsSortedArrayFromIndexMap } from '../../selectors/documentTools';
import { RootState } from '../../store';
import DocumentQueueList from '../Tools/DocumentQueueList';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

interface State {
  readonly selectedDocumentId: number | undefined;
}

class ReorderDocuments extends Component<Props, State> {
  state: State = {
    selectedDocumentId: this.props.documents.length > 0 ? this.props.documents[0].id : undefined,
  };

  onDocumentSelected = (id: number) => {
    this.setState({ selectedDocumentId: id });
  };

  onMoveUp = () => {
    const selectedIndex = this.getIndexById(this.state.selectedDocumentId!);
    this.props.moveDocumentToIndex(this.state.selectedDocumentId!, selectedIndex - 1);
  };

  onMoveDown = () => {
    const selectedIndex = this.getIndexById(this.state.selectedDocumentId!);
    this.props.moveDocumentToIndex(this.state.selectedDocumentId!, selectedIndex + 1);
  };

  onAgreeClick = () => {
    this.props.closeCurrentPopup();
    this.props.applyIndexChanges();
  };

  getIndexById(id: number) {
    return this.props.indexMap![id];
  }

  render() {
    return (
      <Dialog
        title="Reorder Documents"
        submitText="Apply"
        onSubmit={this.onAgreeClick}
        onCancel="close"
        contentSx={{ display: 'flex', mt: 1, ml: 2 }}
      >
        <DocumentQueueList
          documents={this.props.documents}
          onDocumentClick={this.onDocumentSelected}
          selectedDocument={this.props.documents.find((document) => document.id === this.state.selectedDocumentId)}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', pl: 2 }}>
          <IconButton onClick={this.onMoveUp}>
            <ArrowUpwardIcon />
          </IconButton>
          <IconButton onClick={this.onMoveDown}>
            <ArrowDownwardIcon className="downArrowReorder" />
          </IconButton>
        </Box>
      </Dialog>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  indexMap: state.documentTools.indexMap,
  documents: getDocumentsAsSortedArrayFromIndexMap(state),
});

const actionCreators = {
  applyIndexChanges,
  closeCurrentPopup,
  moveDocumentToIndex,
};

export default connect(mapStateToProps, actionCreators)(ReorderDocuments);
